import ArtistProofsFormInputs from './ArtistProofsFormInputs'

export default ArtistProofsFormInputs
